import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const StyledLink = styled(Link)`
	&:hover {
		color: ${(props) => props.theme.v3.colors.blue[6]};
		text-decoration: underline;
	}
`;
